import { paths } from "@rms-types/constants/paths";
import { ConversationSidebarItem } from "@rms-types/modules/conversation/types";

import { ConversationListItem } from "../components";

import { getUnreadMessageCount } from "./getUnreadMessageCount";

import { SidebarItem } from "@/layouts/types";

export function generateConversationSidebar(data: ConversationSidebarItem): SidebarItem[] {
  if (!data) {
    return [];
  }

  return [
    {
      identifier: "inbox",
      label: <ConversationListItem name="Inbox" count={getUnreadMessageCount(data.inbox)} />,
      link:
        data.inbox.length > 0
          ? paths.app.messages.inbox.conversation.details.getLink(data.inbox[0].id)
          : paths.app.messages.inbox.getLink(),
    },
    {
      identifier: "favorites",
      label: <ConversationListItem name="Favorites" count={getUnreadMessageCount(data.favorites)} />,
      link:
        data.favorites.length > 0
          ? paths.app.messages.favorites.conversation.details.getLink(data.favorites[0].id)
          : paths.app.messages.favorites.getLink(),
    },
    {
      identifier: "trash",
      label: <ConversationListItem name="Trash" count={getUnreadMessageCount(data.trash)} />,
      link:
        data.trash.length > 0
          ? paths.app.messages.trash.conversation.details.getLink(data.trash[0].id)
          : paths.app.messages.trash.getLink(),
    },
  ];
}
